// react  library imports
import { useState, useEffect } from 'react';
import Moment from 'moment';
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

// style imports
import "../Date/Date.css";
import "../Input/Input.css";

const TimeField = ({label, id, onChange, initialValue }) => {
    // set state for  focus
    const [focus, setFocus]=useState(true)
    const [value, setValue] = useState(null);

    useEffect(() => {
      // Set initial value using moment to handle Safari compatibility
      if (initialValue) {
        const parsedDate = Moment(initialValue, "YYYY-MM-DD hh:mm A").toDate();
        setValue(parsedDate);
      }
    }, [initialValue]);

    // handle onchange event
    const handleOnChange=(event)=>{
      const time=Moment(new Date(event)).format("YYYY-MM-DD HH:mm")
      if (onChange) {
        onChange(time)
      }
    }
  return (
    <div className="form-input"
    onClick={()=>setFocus(true)}> 
      <DatePicker value={value}   
      format="hh:mm A"
      onChange={handleOnChange}
      disableDayPicker 
      plugins={[
        <TimePicker hideSeconds />
      ]}/>
      <label className={focus ? "form_focus":""} htmlFor={id}>{label}</label>
    </div>
  )
}

export default TimeField